"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.sub");

require("core-js/modules/es6.array.find-index");

var _objectSpread2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/objectSpread2"));

require("core-js/modules/es6.regexp.split");

var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/createForOfIteratorHelper"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/asyncToGenerator"));

var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));

var _wangEditor = _interopRequireDefault(require("@/components/wangEditor"));

var _audit = require("@/api/audit");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    cropUpload: _cropUpload.default,
    textEditor: _wangEditor.default
  },
  props: ['editId'],
  data: function data() {
    return {
      submitForm: {
        category_id: null,
        goods_name: "",
        spread_title: "",
        new_grade: '100',
        rent_label: [],
        imgurl: "",
        carousel_img: [],
        goods_content: "",
        pact_type: '1',
        province: [],
        service_address: "",
        send_out: '1',
        return: '1',
        transfer_cost: ""
      },
      rules: {
        carousel_img: [{
          required: true,
          message: '请上传商品图片',
          trigger: 'blur'
        }],
        province: [{
          required: true,
          message: '请选择服务城市',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '请选择商品品类',
          trigger: 'change'
        }],
        goods_name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        imgurl: [{
          required: true,
          message: '请上传商品封面',
          trigger: 'change'
        }],
        new_grade: [{
          required: true,
          message: '请选择新旧程度',
          trigger: 'change'
        }]
      },
      areaList: [],
      // 服务城市
      adsList: [],
      // 租赁地址
      categoryList: [],
      //品类列表
      optionProps: {
        value: 'id',
        label: 'name',
        expandTrigger: 'hover',
        children: 'sub'
      },
      initData: {
        new_grade: {},
        // 新旧程度
        rent_label: [],
        // 标签
        pact_type: [],
        // 租赁方式
        send_out: {},
        // 寄出
        return: {},
        // 归还
        shop_address: [] // 租赁地址

      },
      goodsParams: [] // 商品参数

    };
  },
  methods: {
    // 获取品类对应的商品参数
    categoryChange: function () {
      var _categoryChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (val) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return (0, _audit.getGoodsParameter)(val).then(function (res) {
                  _this.goodsParams = [];

                  var _iterator = (0, _createForOfIteratorHelper2.default)(res),
                      _step;

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var item = _step.value;
                      item.field_val = "";
                      item.field_list = item.field_list.split(',');

                      _this.goodsParams.push((0, _objectSpread2.default)({}, item));
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function categoryChange(_x) {
        return _categoryChange.apply(this, arguments);
      }

      return categoryChange;
    }(),
    save: function save() {
      var _this2 = this;

      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          // 检查商品参数必填项
          var _iterator2 = (0, _createForOfIteratorHelper2.default)(_this2.goodsParams),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;

              if (item.must_is && (!item.field_val || item.field_val.length === 0)) {
                _this2.$message({
                  message: "商品参数" + item.field_title + "必填",
                  type: "warning"
                });

                return;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({
            goods_id: _this2.editId
          }, _this2.submitForm), {}, {
            operation_type: 3
          });
          data.rent_label = data.rent_label.join(',');
          data.province_id = data.province[0];
          data.show_ity = data.province[1];
          data.carousel_img = data.carousel_img.join(',');
          data.custom = _this2.goodsParams.map(function (item) {
            return {
              'field_title': item.field_title,
              'field_val': item.field_type != 3 ? item.field_val : item.field_val.join(',')
            };
          });
          delete data.province; // console.log(data);

          (0, _audit.editGoodsData)(data).then(function (res) {
            _this2.$router.push({
              name: 'goodsSuccess',
              params: {
                goodsId: _this2.editId
              }
            });
          });
        } else {
          _this2.$message({
            message: "请检查表单错误",
            type: "error"
          });

          return false;
        }
      });
    },
    changeNumberInput: function changeNumberInput(key, value) {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时

      if (!pattern.test(value)) {
        // input 框绑定的内容为空
        this.submitForm[key] = '';
      }
    },
    bannerChange: function bannerChange(val, type) {
      if (type === 'sort') {
        this.submitForm.carousel_img = val;
        return;
      }

      if (type === 'del') {
        this.submitForm.carousel_img.splice(val, 1);
      } else {
        this.submitForm.carousel_img.push(val);
      }

      this.$refs.cropUpload.sortList = this.submitForm.carousel_img;
    },
    setUrl: function setUrl(val) {
      this.submitForm.imgurl = val;
    },
    handleTagClick: function handleTagClick(tag) {
      var index = this.submitForm.rent_label.findIndex(function (item) {
        return item === tag;
      });

      if (index > -1) {
        this.submitForm.rent_label.splice(index, 1);
      } else {
        this.submitForm.rent_label.push(tag);
      }
    },
    // 判断标签是否选中
    isTagCheck: function isTagCheck(tag) {
      return this.submitForm.rent_label.findIndex(function (item) {
        return item === tag;
      }) > -1;
    },
    init: function init() {
      var _this3 = this;

      (0, _audit.getShopCategory)(this.editId).then(function (res) {
        _this3.categoryList = res || [];
      });
      (0, _audit.getGoodsAreas)().then(function (res) {
        _this3.areaList = res ? res[0].sub : [];
      });
      (0, _audit.getGoodsRentData)().then(function (res) {
        if (res) {
          _this3.initData = res;
        }
      });
    },
    getData: function getData() {
      var _this4 = this;

      // 编辑
      (0, _audit.getGoodsData)(this.editId).then( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
          var key, _iterator3, _step3, item, _iterator4, _step4, param;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  for (key in _this4.submitForm) {
                    if (key === 'carousel_img') {
                      _this4.submitForm[key] = res.carousel_images ? res.carousel_images.split(',') : [];
                      _this4.$refs.cropUpload.sortList = _this4.submitForm.carousel_img;
                    } else if (key === 'goods_name') {
                      _this4.submitForm[key] = res.title;
                    } else if (key === 'province') {
                      _this4.submitForm[key] = res.province_id && res.show_ity ? [res.province_id, res.show_ity] : res.province_id ? [res.province_id] : [];
                    } else if (key === 'rent_label') {
                      _this4.submitForm[key] = res.rent_label.split(',');
                    } else if (key === 'pact_type') {
                      _this4.submitForm[key] = res.pact_type + '';
                    } else if (key === 'return') {
                      _this4.submitForm[key] = res.convey_type2 + '';
                    } else if (key === 'send_out') {
                      _this4.submitForm[key] = res.convey_type1 + '';
                    } else if (res[key]) {
                      _this4.submitForm[key] = res[key];
                    }
                  }

                  console.log(_this4.submitForm);
                  _context2.next = 4;
                  return _this4.categoryChange(res.category_id);

                case 4:
                  _iterator3 = (0, _createForOfIteratorHelper2.default)(res.attribute);

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      item = _step3.value;
                      _iterator4 = (0, _createForOfIteratorHelper2.default)(_this4.goodsParams);

                      try {
                        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                          param = _step4.value;

                          if (item.field_title === param.field_title) {
                            param.field_val = param.field_type == 3 ? item.field_val.split(',') : item.field_val;
                          }
                        }
                      } catch (err) {
                        _iterator4.e(err);
                      } finally {
                        _iterator4.f();
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  mounted: function mounted() {
    this.init();
    this.getData();
  }
};
exports.default = _default;